<template>
	<div>
		<div class="itinerary_item_head">
			<h3>
				{{ item.item_name }} 
				<span v-if="upgrade_options && upgrade_options.length > 1">upgrades available</span>
				<small v-if="item.option_name">{{ item.option_name }}</small>
			</h3>
			<button type="button" class="chevron">
				<i class="fas fa-fw fa-chevron-down flip"></i>
			</button>
		</div>

		<div class="itinerary_item_body">
			<div class="itinerary_item_body_inner">
				<div class="image">
					<img :src="item.thumb" :alt="item.item_name">
				</div>
				<div class="details">

					<p class="info" v-if="item.sash">{{ item.sash }}</p>

					<p class="upgrade_price" v-if="upgrade_options && upgrade_options.length > 1 && item.upgrade_price_per_person != 0">
						<template v-if="item.upgrade_price_per_person > 0">
							<span><b>+ {{ formatCurrency(item.upgrade_price_per_person) }}</b> per person</span>
						</template>
						<template v-else>
							<span><b>- {{ formatCurrency(0-item.upgrade_price_per_person) }}</b> per person</span>
						</template>
					</p>

					<p class="time" v-if="item.friendly_time">{{ item.friendly_time }}</p>

					<p class="people" v-if="item.number_of_participants != 0">For {{ item.number_of_participants }} {{ item.number_of_participants==0 ? 'person' : 'people' }}</p>

					<template v-if="data.show_final_confirmations">
						<p class="address" v-if="item.location_address">{{ item.location_address }}</p>
						<p class="phone" v-if="item.location_telephone">{{ item.location_telephone }}</p>
					</template>

					<p v-if="item.excerpt">{{ nl2br(item.excerpt) }}</p>

					<p v-if="item.notes_for_customer"><b>Notes:</b> {{ item.notes_for_customer }}</p>

					<template v-if="item.more_info">
						<span class="spacer"></span>
						<button type="button" class="button small solid" :data-featherlight="'/ajax/activity-details/' + item.activity_id" data-featherlight-after-open="doActivitySlickInPopup()">
							<span class="fa-stack fa-1x">
								<i class="fal fa-circle fa-stack-2x"></i>
								<i class="fas fa-info fa-stack-1x"></i>
							</span>
							More Info
						</button>
					</template>

				</div>

				<div class="upgrades" v-if="status=='Quote Sent' && upgrade_options && upgrade_options.length > 1">
					<h4>Upgrades</h4>
					<div class="upgrade_item" v-for="(upgrade_option, upgrade_key) in upgrade_options" v-if="upgrade_option.activity_id != item.activity_id">
						<div class="upgrade_item_image" v-if="upgrade_option.thumb">
							<img :src="upgrade_option.thumb" :alt="upgrade_option.item_name">
						</div>
						<div class="upgrade_item_content">
							<h5>{{ upgrade_option.item_name }}</h5>
							<p>
								<b>
									<template v-if="parseFloat(upgrade_option.upgrade_price_per_person) - parseFloat(item.upgrade_price_per_person) < 0">
									-
									</template>
									<template v-else>
									+
									</template>
									{{ formatCurrency(Math.abs(parseFloat(upgrade_option.upgrade_price_per_person) - parseFloat(item.upgrade_price_per_person)))}}
								</b>
								per person
							</p>
							<span class="spacer"></span>
							<div class="buttons">
								<button v-if="controls" v-on:click="swapOption(upgrade_key)" type="button" class="button small solid black" :style="'--accent:' + accent">
									<span class="fa-stack fa-1x">
										<i class="fal fa-random fa-stack-2x"></i>
									</span>
									Swap
								</button>
								<button v-if="upgrade_option.more_info" type="button" class="button small solid" :data-featherlight="'/ajax/activity-details/' + upgrade_option.activity_id" data-featherlight-after-open="doActivitySlickInPopup()">
									<span class="fa-stack fa-1x">
										<i class="fal fa-circle fa-stack-2x"></i>
										<i class="fas fa-info fa-stack-1x"></i>
									</span>
									More Info
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: {
		data: {},
		accent: {},
		controls: false,
		status: '',
		default_selected_upgrade: null
	},

	data: () => {
		return {
			item: {},
			upgrade_options: {},
		}
	},

	computed: {

	},

	mounted() {
		this.item = this.data;
		this.upgrade_options = this.data.upgrade_options;

		if (this.upgrade_options != null && this.upgrade_options.length > 1 && this.default_selected_upgrade != '' && this.default_selected_upgrade != null) {
			for (var key in this.upgrade_options) {
				if (this.upgrade_options[key].activity_id == this.default_selected_upgrade) {
					this.swapOption(key);
				}
			}
		}
	},

	methods: {

		swapOption: function (upgrade_key) {

			var option = this.upgrade_options[upgrade_key];
			this.item.thumb = option.thumb;
			this.item.item_name = option.item_name;
			this.item.excerpt = option.excerpt;
			this.item.more_info = option.more_info;
			this.item.upgrade_price_per_person = option.upgrade_price_per_person;
			this.item.activity_id = option.activity_id;

			// var new_total = parseFloat(this.item.default_booking_price_per_person) + parseFloat(this.item.upgrade_price_per_person);
			// $('#price_per_person').html(this.formatCurrency(new_total));

			// set a session
			var self = this;
			axios.post('/ajax/setUpgradeOption', {
				booking_item_id: this.data.id,
				activity_id: this.item.activity_id,
			})
			.then(response => {
				$("#price_per_person").html(this.formatCurrency(response.data.total_per_person));
				$("[data-ref='deposit_1']").html(response.data.deposit_1);
				$("[data-ref='deposit_2']").html(response.data.deposit_2);
				$("[data-ref='deposit_2_days']").html(response.data.deposit_2_days);
				this.$root.$refs.paymentform.setDeposit(response.data.deposit_1);
			})
			.catch(error => {
			});
		},

		nl2br: function (str, is_xhtml) {
			if (typeof str === 'undefined' || str === null) {
				return '';
			}
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
		},

		formatCurrency: function (value) {
			return "£" + this.numberWithCommas((Math.round( (parseFloat(value) + 0.0001) * 100 ) / 100).toFixed(2));
		},

		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
	}
}
</script>